export interface Empresa {
  empresaId: number;
  nombreEmpresa: string;
  activa: boolean;
  fechaCreacion: string;
  licenciaActiva: boolean;
  fechaExpiracionLicencia: string | null;
  fechaUltimoPago: string | null;
  planActual: string | null;
  notasLicencia: string | null;
  horaInicio: string;
  horaFin: string;
}

export interface CreateEmpresaDto {
  nombreEmpresa: string;
  activa: boolean;
  licenciaActiva: boolean;
  fechaExpiracionLicencia: string | null;
  planActual: string | null;
  notasLicencia: string | null;
  horaInicio: string;
  horaFin: string;
}

export interface UpdateEmpresaDto {
  nombreEmpresa: string;
  activa: boolean;
  licenciaActiva: boolean;
  fechaExpiracionLicencia: string | null;
  fechaUltimoPago: string | null;
  planActual: string | null;
  notasLicencia: string | null;
  horaInicio: string;
  horaFin: string;
}

class EmpresasService {
  private baseUrl: string;

  constructor() {
    this.baseUrl = import.meta.env.VITE_API_BASE_URL || 'https://localhost:7123/api';
  }

  private getHeaders(): Record<string, string> {
    const headers: Record<string, string> = {
      'Content-Type': 'application/json',
    };

    const token = localStorage.getItem('authToken');
    if (token) {
      headers.Authorization = `Bearer ${token}`;
    }

    return headers;
  }

  private async request<T>(endpoint: string, options: RequestInit = {}): Promise<T> {
    const url = `${this.baseUrl}${endpoint}`;

    const response = await fetch(url, {
      ...options,
      headers: this.getHeaders(),
    });

    if (!response.ok) {
      const errorData = await response.json().catch(() => ({
        message: 'Error en la conexión con el servidor',
      }));
      throw new Error(errorData.message || `Error HTTP: ${response.status}`);
    }

    if (response.status === 204) {
      return {} as T;
    }

    return response.json();
  }

  async getAll(): Promise<Empresa[]> {
    return this.request<Empresa[]>('/empresas');
  }

  async getById(id: number): Promise<Empresa> {
    return this.request<Empresa>(`/empresas/${id}`);
  }

  async create(data: CreateEmpresaDto): Promise<Empresa> {
    return this.request<Empresa>('/empresas', {
      method: 'POST',
      body: JSON.stringify(data),
    });
  }

  async update(id: number, data: UpdateEmpresaDto): Promise<Empresa> {
    return this.request<Empresa>(`/empresas/${id}`, {
      method: 'PUT',
      body: JSON.stringify(data),
    });
  }

  async delete(id: number): Promise<void> {
    await this.request<void>(`/empresas/${id}`, {
      method: 'DELETE',
    });
  }
}

export const empresasService = new EmpresasService();
